import React, { useState, useContext } from 'react';

import Sidebar from '../../components/Sidebar';
import MenuResponsive from '../../components/MenuResponsive/index';
import Tab from '../../components/Tab';
import SchedulesAndPaid from './SchedulesAndPaid';

import logo from '../../Assets/logo.png';

import { Background, Container, Main } from '../../styles/GenericStyles';

import { UserContext } from '../../UserContext';

const Home: React.FC = () => {
  const { isBackgroundFixed } = useContext(UserContext);
  const [isSelect, setIsSelect] = useState<boolean>(true);

  return (
    <Background isBackgroundFixed={isBackgroundFixed}>
      <Container>
        <MenuResponsive />
        <Sidebar />
        <Main>
          <img src={logo} width="152" height="76" alt="FAEL" />
          <section>
            <Tab
              tab1="Agendamentos"
              tab2="Pagas"
              isSelect={isSelect}
              setIsSelect={setIsSelect}
              className="tab"
              checkout={false}
            />
            <SchedulesAndPaid isSelect={isSelect} />
          </section>
        </Main>
      </Container>
    </Background>
  );
};

export default Home;
